import { ReelSpin } from "./ReelSpin";
// import { Ui } from "../uiBGaming/Ui";

import { Spine } from '@esotericsoftware/spine-pixi-v8';
import { BitmapText, Container } from 'pixi.js';
import { /*Tween,*/ Group, Tween } from "tweedle.js";

import { /*SpinDataObject,*/ spinData, WinObject } from '../../server/getServerResposesFun';

import {
    REEL_DIVIDER,
    REEL_NUMBERS,
    REEL_WIDTH,
    SYMBOL_HEIGHT,
    SYMBOLS_PER_REEL
} from "../../config/reelConfig";

import { isQuickBtnOnGlobal, isSuperQuickBtnOnGlobal, jurisdictionGlobal, linesConfigGlobal } from "../../config/GlobalVariableConfig";
import { SoundConstants } from "../../gameClientEvents/SoundConstants";
import { SoundManager } from "../SoundManager";

// import { SETLINENUMBER } from "../config/customEvent";

let lineWinText: BitmapText;

export interface CancellationToken {
    isCancelled: boolean;
}

let lineWinTextContainer: Container;
let textTweenGroup: Group;

export class ReelWin extends ReelSpin {


    protected winSymbolArray: number[][] = [];

    public winLines: WinObject[] | null = null; // object for winning Lines
    protected winLinesSPine: Spine | null = null;
    protected toggleWinLinesSpine: Spine | null = null;

    protected currentAnimationCancellationToken: CancellationToken | null = null;
    protected paylineYOffset: number = 0;

    constructor() {
        super();



        lineWinText = new BitmapText({
            text: '',
            style: {
                fontFamily: "scarab_wins_digit",
                trim: true,
                fontSize: 70,
                // letterSpacing: 10,
            }

        });

        lineWinTextContainer = new Container();
        lineWinTextContainer.label = "lineWinTextContainer";

        textTweenGroup = new Group();

        // this.reelOverlayContainer.addChild(this.lineWinText);

        textTweenGroup.removeAll();

        this.setupLineWintext();

        this.setWinLineSpineObj();

    }


    public updateReelWin() {
        this.updateReelSpin();

        textTweenGroup?.update();

    }


    protected setWinLineSpineObj() {

        this.winLinesSPine = Spine.from({
            skeleton: "winLineSkel",
            atlas: "winLineAtlas",
        });

        this.winLinesSPine.state.clearTracks();
        this.winLinesSPine.label = "WinsLine"

        this.reelOverlayContainer.addChild(this.winLinesSPine);
        this.winLinesSPine.position.set(638, 550);

        this.toggleWinLinesSpine = Spine.from({
            skeleton: "winLineSkel",
            atlas: "winLineAtlas",
        });

        this.toggleWinLinesSpine.state.clearTracks();

        this.toggleOverlayContainer.addChild(this.toggleWinLinesSpine);
        this.toggleWinLinesSpine.position.set(638, 550);
        // this.winLinesSPine.position.set(415, 410);
        // this.winLinesSPine?.state.setAnimation(0, "payline_0", true);
        // this.winLinesSPine?.state.setAnimation(1, "payline_1", true);
        // this.winLinesSPine?.state.setAnimation(2, "payline_2", true);
        // this.winLinesSPine?.state.setAnimation(3, "payline_3", true);
        // this.winLinesSPine?.state.setAnimation(4, "payline_19", true);
    }

    /*protected async waitFunction(time: number): Promise<void> {
        return new Promise((resolve) => {

            setTimeout(() => {
                resolve();
            }, time);

        })
    }*/

    protected async wait(ms: number) {
        return new Promise((resolve) => {
            new Tween({})
                .delay(ms)
                .onAfterDelay(resolve) // Resolve the promise when delay ends
                .start();
        });
    }

    protected initWinSymbolArray() {
        // Initialize winSymbolArray with zeros
        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.winSymbolArray[i] = [];
            for (let j = 0; j < SYMBOLS_PER_REEL; j++) {
                this.winSymbolArray[i][j] = 0; // Initialize to 0
            }
        }
    }

    // export interface WinObject { // the object -how we want to use in our program 
    //     lineId: number | null;
    //     symbolId: number;
    //     winAmount: number;
    //     winSymbolPosistions: number[][]| null;
    // }


    // setWinSymbolArray will be modified according to cat expansion
    protected setWinSymbolArray(winObjects: WinObject[]) {
        // Iterate through winLines
        winObjects?.forEach((winObject) => {
            if (winObject.winSymbolPosistions) {
                // Adjust the type of reelNum and posNum to number

                winObject.winSymbolPosistions.forEach((winSymbolPosistion) => {

                    let reelNum: number = winSymbolPosistion[0];
                    let posNum: number = winSymbolPosistion[1];

                    // Mark the position as 1
                    this.winSymbolArray[reelNum][posNum] = 1;
                })
            }
        });
    }


    // this is main function which is doing the animation -
    public async animateAllWinningSymbols(currentRespinIndex: number): Promise<void> {

        return new Promise(async (resolve) => {

            if (spinData.respins[currentRespinIndex].winAmount == 0 || spinData.respins[currentRespinIndex].winLines === null) {
                // this.running = false;
                resolve();
            }
            else {

                //  this.setWinSymbolArray(this.winScatters);

                this.winLines = spinData.respins[currentRespinIndex].winLines;

                const winSymbolIds = [...new Set(this.winLines.map(line => line.symbolId))];

                for (let i = 0; i < winSymbolIds.length; i++) {
                    const symbolId = winSymbolIds[i];

                    const matchingWinLines = this.winLines.filter(line => line.symbolId === symbolId);
                    const winlineNumbers: number[] = [...new Set(matchingWinLines.map(line => line.lineId))];

                    let winAmount = 0;
                    matchingWinLines.forEach((winLine) => {
                        winAmount = winAmount + winLine.winAmount;
                    })

                    this.initWinSymbolArray();
                    this.setWinSymbolArray(matchingWinLines);

                    const winMultiplier = matchingWinLines[0].winMultiplier;

                    await this.animateWinLine(winlineNumbers, winAmount, winMultiplier);

                    if (winSymbolIds.length > 1) {

                        if (!isSuperQuickBtnOnGlobal && !isQuickBtnOnGlobal) {
                            await new Promise((resolve) => setTimeout(resolve, 200));
                        }
                    }
                }

                //animate win scatters
                // this.winScatters = spinData.respins[currentRespinIndex].winScatters;

            }

            console.log("all line animations are completed");

            resolve();
        })
    }

    public resetReelOverlayContFromToggle() {
        // this.toggleWinLinesSpine!.state.clearTracks();
        this.toggleOverlayContainer.removeChild(this.toggleWinLinesSpine);
        this.toggleOverlayContainer.removeChild(lineWinTextContainer);

        this.reelOverlayContainer.removeChild(this.winLinesSPine);
        this.reelOverlayContainer.removeChild(lineWinTextContainer);
        this.resetOverlaySymbolLayerOrder();
        this.resetAllSymbols();
        lineWinText.text = "";
        lineWinText.scale = 1;
        if (this.currentAnimationCancellationToken !== null)
            this.currentAnimationCancellationToken.isCancelled = true;
    }

    public resetWinsOnBetChange() {
        this.winLines = [];
        this.resetReelOverlayContFromToggle();
    }

    public async lineToggle(currentRespinIndex: number) {
        if (this.running) return;

        console.log("inside lineToggle");
        this.winLines = spinData.respins[currentRespinIndex].winLines;
        if (!this.winLines) return;

        // --- CANCELLATION STEP 1: Create a new token for this sequence ---
        const token: CancellationToken = { isCancelled: false };
        this.currentAnimationCancellationToken = token;

        try {
            do {
                for (const winLine of this.winLines) {
                    if (!winLine || this.winLines.length <= 0) return;

                    // Add a check here as well if waitFunction is long/interruptible
                    await this.wait(this.winLines.length > 1 ? 1000 : 2000);

                    if (this.running || this.winLines.length <= 0 || token?.isCancelled) {
                        return; // Check cancellation flag here too
                    }

                    const lineId = winLine.lineId;
                    const winAmount = winLine.winAmount;
                    const winMultiplier = winLine.winMultiplier;

                    this.toggleOverlayContainer.addChild(this.toggleWinLinesSpine);
                    this.toggleOverlayContainer.addChild(lineWinTextContainer);

                    lineWinTextContainer.y = (0.5 + linesConfigGlobal[lineId][2]) * SYMBOL_HEIGHT + this.paylineYOffset;

                    // --- CANCELLATION STEP 2: Pass the token to the animation function ---
                    await Promise.all([
                        this.playWinLineAnimationsToggle([lineId], 1, token), // Pass the token here
                        this.updateNumberText(winAmount / winMultiplier, winMultiplier, true),
                    ]);

                    // Break immediately if the next spin is called OR if cancelled
                    if (this.running || this.winLines.length <= 0 || token?.isCancelled) {
                        return;
                    }
                }

            } while (!this.running && this.winLines.length > 0 && !token?.isCancelled);
            // Add token check to loop condition

        } catch (reason) {
            if (reason === 'cancelled') {
                console.log("lineToggle sequence exited silently due to cancellation.");
            } else {
                console.error("An unexpected error occurred:", reason);
                throw reason;
            }
        } finally {
            // --- CANCELLATION STEP 3: Cleanup the token reference ---
            if (this.currentAnimationCancellationToken === token) {
                this.currentAnimationCancellationToken = null;
            }
        }
    }




    protected winningSymbolOnTop() {
        // this.reset
        // first take winning symbol on top

        // this.overlayConDarkLayer.visible = true;
        // this.reelOverlayContainer.addChild(this.overlayConDarkLayer);

        this.winSymbolArray.forEach((reels, reelNum) => {
            reels.forEach((symbol, posNum) => {
                if (symbol == 1) // win animation
                {
                    // take them on top
                    const symbolCont = this.reelSymbolContainers[reelNum][posNum];
                    if (symbolCont) {
                        this.reelOverlayContainer.addChild(symbolCont);
                    }

                }
            })
        })

        // then take oversized symbol on top of that
        this.winSymbolArray.forEach((reels, reelNum) => {
            reels.forEach((symbol, posNum) => {
                if (symbol == 1) // win animation
                {
                    const symbolId: number = this.allReelArray[reelNum].symbols[posNum].id;

                    if (symbolId == 0) // symbolId of oversized symbols 
                    {
                        // take them on top
                        const symbolCont = this.reelSymbolContainers[reelNum][posNum];
                        if (symbolCont) {
                            this.reelOverlayContainer.addChild(symbolCont);
                        }

                    }
                }
            })
        })
    }

    protected resetOverlaySymbolLayerOrder() {

        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL; posNum++) {
                const symbolCont = this.reelSymbolContainers[reelNum][posNum];
                if (symbolCont) {
                    this.reelOverlayContainer.addChild(symbolCont);
                }
            }
        }
    }


    // Function to calculate position based on lineNumber

    protected resetAllSymbols() {

        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL; posNum++) {
                let symbol = this.reelSymbols[reelNum][posNum];
                if (symbol) {
                    symbol.tint = "0xffffff";
                }
            }
        }
    }

    protected playWinLineAnimations(winlineNumbers: number[], timeScale: number): Promise<void> {
        return new Promise((resolve) => {
            // Clear any existing tracks
            this.winLinesSPine?.state.clearTracks();

            const animationPromises: Promise<void>[] = [];

            // Set paying line animations for each winning line
            for (let currentLineIndex = 0; currentLineIndex < winlineNumbers.length; currentLineIndex++) {
                const winLineId = winlineNumbers[currentLineIndex];
                const winAnimationName = `payline_${winLineId}`;

                const animationPromise = new Promise<void>((resolve2) => {
                    let listener = {
                        complete: () => {
                            resolve2();
                            this.winLinesSPine!.state.removeListener(listener);
                        },
                    };
                    this.winLinesSPine!.state.addListener(listener);
                    this.winLinesSPine!.state
                        .setAnimation(currentLineIndex, winAnimationName, false);

                    this.winLinesSPine!.state.timeScale = timeScale;
                });

                animationPromises.push(animationPromise);
            }

            // Resolve when all animations complete
            Promise.all(animationPromises).then(() => resolve());
        });
    }


    // Add the CancellationToken parameter
    protected playWinLineAnimationsToggle(winlineNumbers: number[], timeScale: number, token?: CancellationToken): Promise<void> {

        // We change resolve() to reject() as well, since Promise.all needs a rejection to stop immediately
        return new Promise((resolve, reject) => {
            // If already cancelled before we even start the animations, reject immediately
            if (token?.isCancelled) {
                return reject('cancelled');
            }

            this.toggleWinLinesSpine!.state.data.defaultMix = 0;
            this.toggleWinLinesSpine?.state.clearTracks();

            const animationPromises: Promise<void>[] = [];

            for (let currentLineIndex = 0; currentLineIndex < winlineNumbers.length; currentLineIndex++) {
                const winLineId = winlineNumbers[currentLineIndex];
                const winAnimationName = `payline_${winLineId}`;

                const animationPromise = new Promise<void>((resolve2, reject2) => { // Added reject2
                    let listener = {
                        complete: () => {
                            // --- CANCELLATION STEP 4: Check the token upon completion ---
                            if (token?.isCancelled) {
                                // Reject this inner promise if cancelled
                                reject2('cancelled');
                            } else {
                                // Otherwise, resolve normally
                                resolve2();
                            }
                            this.toggleWinLinesSpine!.state.removeListener(listener);
                        },
                    };

                    // Also check token immediately before setting animation if possible, 
                    // though the complete listener usually handles runtime cancellation well
                    if (token?.isCancelled) {
                        return reject2('cancelled');
                    }

                    this.toggleWinLinesSpine!.state.addListener(listener);
                    this.toggleWinLinesSpine!.state
                        .setAnimation(currentLineIndex, winAnimationName, false);
                    this.toggleWinLinesSpine!.update(0);
                    this.toggleWinLinesSpine!.state.timeScale = timeScale;
                });

                animationPromises.push(animationPromise);
            }

            // Resolve when all animations complete, or automatically reject if any single promise rejects
            Promise.all(animationPromises)
                .then(() => {
                    // Double check before resolving the master promise
                    if (token === null || !token?.isCancelled) {
                        resolve();
                    } else {
                        reject('cancelled');
                    }
                })
                .catch(reason => {
                    // Forward the rejection reason up to the caller (lineToggle's try/catch)
                    reject(reason);
                });
        });
    }

    protected async runAnimation(winlineNumbers: number[]): Promise<void> // play animation of symbols having value 1 in the array winSymbolArray
    {

        console.log("inside runAnimation");

        const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

        const animationPromises: Promise<void>[] = [];

        const winLineAnimationPromise = this.playWinLineAnimations(winlineNumbers, timeScale);
        animationPromises.push(winLineAnimationPromise);


        this.winSymbolArray.forEach((reels, reelNum) => {
            reels.forEach((value, posNum) => {
                let symbol = this.reelSymbols[reelNum][posNum]

                const symbolId = this.allReelArray[reelNum].symbols[posNum].id;

                if (value == 1) {
                    const animationPromise = new Promise<void>((resolve) => {

                        if (symbolId == 0) { // wild
                            let listener = {
                                complete: () => {
                                    // symbol.state.setAnimation(0, "idle", true);
                                    symbol.state.timeScale = 1;
                                    resolve();
                                    symbol.state.removeListener(listener);
                                }
                            };
                            symbol.state.addListener(listener);
                            symbol.state.setAnimation(0, "win", false);
                            symbol.state.timeScale = timeScale;
                        }
                        else {
                            let listener = {
                                complete: () => {
                                    resolve();
                                    symbol.state.removeListener(listener);
                                }
                            };
                            symbol.state.addListener(listener);
                            symbol.state.setAnimation(0, "win", false);
                            symbol.state.timeScale = timeScale;
                        }
                    })

                    animationPromises.push(animationPromise);
                }
                else {
                    symbol.tint = "0x555555";
                }
            }
            )
        })

        try {
            if (animationPromises.length > 0) {
                await Promise.all(animationPromises);
            }
        } catch (error) {
            console.error("Error during runAnimation:", error);
            throw error;
        }

    }


    protected async animateWinLine(winlineNumbers: number[], winAmt?: number, currentMult?: number): Promise<void> {

        console.log("animateWinLine", winlineNumbers)

        this.resetOverlaySymbolLayerOrder();

        // Handle winning symbols
        this.winningSymbolOnTop();

        // Add the win lines spine to the overlay container if there are winning lines
        if (winlineNumbers.length > 0 && this.winLinesSPine) {
            this.reelOverlayContainer.addChild(this.winLinesSPine);
        }

        // on top of reelOverlayContainer
        this.reelOverlayContainer.addChild(lineWinTextContainer);

        // Initialize text animation if winAmt is non-zero
        // let textanimate: TextAnimate | null = null;
        try {
            if (winAmt) {

                const textAnimationY = this.getTextAnimatePos();
                lineWinTextContainer.y = textAnimationY;

                await Promise.all([
                    this.runAnimation(winlineNumbers),
                    this.updateNumberText(winAmt / currentMult, currentMult)

                ]);

            }
            else {
                await this.runAnimation(winlineNumbers);
            }
        } finally {
            this.resetAllSymbols();
            this.resetOverlaySymbolLayerOrder();
        }
    }

    protected setupLineWintext() {

        lineWinTextContainer.label = "lineWinTextContainer";
        lineWinText.anchor = 0.5;
        lineWinTextContainer.addChild(lineWinText);

        this.reelOverlayContainer.addChild(lineWinTextContainer);

        // new TextAnimate(textTweenGroup, winAmt, decimalPlace, texttickupDuration, textanimationDuration);
        lineWinTextContainer.x = (REEL_WIDTH * REEL_NUMBERS + (REEL_NUMBERS - 1) * REEL_DIVIDER) / 2;


    }

    protected getTextAnimatePos(): number {

        const mappedArray = this.winSymbolArray[0].map((_, colIndex) =>
            this.winSymbolArray.some(row => row[colIndex] === 1) ? 1 : 0
        );

        // Step 2: Get indexes with 1s
        const indexesWithOnes = mappedArray
            .map((value, index) => (value === 1 ? index : -1))
            .filter(index => index !== -1);

        // Step 3: Calculate Median
        let median: number;
        const len = indexesWithOnes.length;

        if (len === 0) {
            median = -1; // Handle case with no 1s
        } else if (len % 2 === 0) {
            median = (indexesWithOnes[len / 2 - 1] + indexesWithOnes[len / 2]) / 2;
        } else {
            median = indexesWithOnes[Math.floor(len / 2)];
        }

        // console.log("Mapped Array:", mappedArray);        // [1, 1, 1, 1, 1, 0]
        // console.log("Indexes with 1s:", indexesWithOnes); // [0, 1, 2, 3, 4]
        // console.log("Median index:", median);             // 2

        return (median + 0.5) * SYMBOL_HEIGHT + this.paylineYOffset;


    }


    protected async updateNumberText(winAmt: number, currentMult?: number, callFromToggle: boolean = false): Promise<void> {
        // console.log(`currentMult ${currentMult}`);

        return new Promise(async (resolve) => {

            if (isSuperQuickBtnOnGlobal && !callFromToggle) {

                let targetVal: number = winAmt * currentMult;
                lineWinText.text = `${(targetVal).toFixed(2)}`;

                lineWinText.scale = 1;
                const textScale = Math.min(850 / lineWinText.width, 1);
                lineWinText.scale = textScale;

                if (["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 && !spinData.isWinHigherBet) {
                    // SoundManager.play('symbol_win_multiply', { volume: 0 })
                }
                else {
                    if (callFromToggle !== true) {
                        SoundManager.play(SoundConstants.SYMBOL_WIN, { volume: 0.4 })
                    }
                }

                await this.wait(500);

                lineWinText.text = "";
                lineWinText.scale = 1;

                await this.wait(100);

                resolve();

                return;
            }


            // if super turbo is not there

            if (currentMult && currentMult > 1) {
                lineWinText.text = `${winAmt.toFixed(2)} x ${currentMult}`;
            }
            else {
                lineWinText.text = `${winAmt.toFixed(2)}`;
            }

            lineWinText.scale = 1;
            const textScale = Math.min(850 / lineWinText.width, 1);
            lineWinText.scale = textScale;

            if (["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 && !spinData.isWinHigherBet) {
                // SoundManager.play('symbol_win', { volume: 0 })
            }
            else {
                // SoundManager.play('symbol_win', { volume: .3 })
                if (callFromToggle !== true) {
                    SoundManager.play(SoundConstants.SYMBOL_WIN, { volume: .4 })
                }
            }

            await this.wait(500);

            if (currentMult && currentMult > 1) {

                let currentVal: number = winAmt;
                let targetVal: number = winAmt * currentMult;
                const tweenToTickup = new Tween({ x: currentVal }, textTweenGroup)
                    .to({ x: targetVal }, 100)
                    .onStart(() => {
                        // SoundManager.play('symbol_win_multiply', { volume: 0.2 });

                        if (["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 && !spinData.isWinHigherBet) {
                            // SoundManager.play('symbol_win_multiply', { volume: 0 })
                        }
                        else {
                            if (callFromToggle !== true) {
                                SoundManager.play('symbol_win_multiply', { volume: 0.35 })
                            }
                        }
                    })
                    .onUpdate((object) => {
                        lineWinText.text = `${(currentVal).toFixed(2)}`;
                        currentVal = object.x; // Update currentVal with the tweened value
                        // console.log(`in tween currentVal: ${currentVal}`);
                    })
                    .onComplete(() => {
                        lineWinText.text = `${(targetVal).toFixed(2)}`;
                        textTweenGroup.remove(tweenToTickup)
                    })
                    .start();

                await this.wait(500);

            }
            else {
                await this.wait(500);
            }

            lineWinText.text = ``;
            lineWinText.scale = 1;

            resolve();
        })

    }


    public async processWinFeatureSymbol(): Promise<void> {

        return new Promise(async (resolve) => {

            this.initWinSymbolArray();
            const scatterSymbolId = 12;
            let scatterCount = 0;
            for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
                for (let posNum = 0; posNum < SYMBOLS_PER_REEL; posNum++) {
                    if (this.allReelArray[reelNum].symbols[posNum].id == scatterSymbolId) {
                        this.winSymbolArray[reelNum][posNum] = 1;
                        scatterCount++;
                    }
                }
            }

            if (scatterCount > 0) {
                SoundManager.play(SoundConstants.SCATTER_TRIGGER);
                await this.animateWinLine([]);
            }
            else {
                await new Promise((resolve) => setTimeout(resolve, 500));
            }

            resolve();
        })

    }

}